import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const MemberCtx = createContext(null);
const AdminCtx = createContext(null);

export const MemberAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("swk_member_token"));
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    if (!token) {
      setProfile(null);
      return;
    }
    api
      .get("/members/me")
      .then((r) => setProfile(r.data))
      .catch(() => {
        localStorage.removeItem("swk_member_token");
        setToken(null);
        setProfile(null);
      });
  }, [token]);

  const login = useCallback((newToken, prof) => {
    localStorage.setItem("swk_member_token", newToken);
    setToken(newToken);
    if (prof) setProfile(prof);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("swk_member_token");
    setToken(null);
    setProfile(null);
  }, []);

  return (
    <MemberCtx.Provider value={{ token, profile, login, logout, isAuthed: !!token }}>
      {children}
    </MemberCtx.Provider>
  );
};

export const useMemberAuth = () => useContext(MemberCtx);

export const AdminAuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem("swk_admin_token"));
  const [email, setEmail] = useState(() => localStorage.getItem("swk_admin_email"));

  const login = useCallback((newToken, newEmail) => {
    localStorage.setItem("swk_admin_token", newToken);
    localStorage.setItem("swk_admin_email", newEmail);
    setToken(newToken);
    setEmail(newEmail);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("swk_admin_token");
    localStorage.removeItem("swk_admin_email");
    setToken(null);
    setEmail(null);
  }, []);

  return (
    <AdminCtx.Provider value={{ token, email, login, logout, isAuthed: !!token }}>
      {children}
    </AdminCtx.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminCtx);
